export default __webpack_public_path__ + "static/media/qr-code.524029fa.svg";